export default __webpack_public_path__ + "images/7420f9b56caf4f694cd27d96b97a4f60.png";